export function mapOrder(array: { [k: string]: any }[], order: string[], key: string) {
  array.sort((a, b) => {
    const A = a[key];
    const B = b[key];
    return order.indexOf(A) > order.indexOf(B) ? 1 : -1;
  });
  return array;
}
